import type { BusinessProfileEntity } from './business-profile.model';
import { EntityListEditor } from './EntityListEditor';

export type DivisionsEditorProps = {
  divisions: BusinessProfileEntity[];
  isReadOnly: boolean;
  isSaving: boolean;
  onSave: (divisions: BusinessProfileEntity[]) => Promise<boolean>;
};

export function DivisionsEditor({
  divisions,
  isReadOnly,
  isSaving,
  onSave,
}: DivisionsEditorProps) {
  return (
    <EntityListEditor
      values={divisions}
      isReadOnly={isReadOnly}
      isSaving={isSaving}
      onSave={onSave}
      translationsNamespace="designSystem.networkSettings.businessProfile.divisions"
    />
  );
}
